import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M6 5l0 14","key":"svg-0"}],["path",{"d":"M10 5l0 14","key":"svg-1"}],["path",{"d":"M14 5l0 14","key":"svg-2"}],["path",{"d":"M18 5l0 14","key":"svg-3"}]]

const IconTallymark4 = createReactComponent('outline', 'tallymark-4', 'Tallymark4', __iconNode);

export default IconTallymark4;